import React from 'react';

import { useSnackbar } from 'notistack';

import { Stack, Typography } from '@mui/material';

import { useRefreshPropertyDebug } from '~/hooks/apis/accommodation/usePropertyDebug';

import { formatDateLongMonthWithMeridiem } from '~/services/TimeService';

import PropertyActionCard from './PropertyActionCard';

interface Props {
  propertyId: string;
}

export default function PropertyMappingCacheAction({ propertyId }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const refreshMutation = useRefreshPropertyDebug();

  const onRefresh = () => {
    refreshMutation.mutate(
      { propertyId },
      {
        onSuccess: () => enqueueSnackbar('Mapping and indicative caches regenerated', { variant: 'success' }),
      },
    );
  };

  const lastUpdated = refreshMutation.data?.lastUpdated;

  return (
    <PropertyActionCard
      title="Mapping & indicative cache"
      description="Rebuild the mappings cache and the indicative property state for this property. Both are regenerated by the same job."
      buttonLabel="Regenerate mapping cache"
      onClick={onRefresh}
      isLoading={refreshMutation.isPending}
      disabled={!propertyId}
      errorMessage={refreshMutation.error?.message}
    >
      {lastUpdated && (
        <Stack spacing={0.5}>
          <Typography variant="body2">
            Mappings cache updated:{' '}
            {lastUpdated.mappingsCache ? formatDateLongMonthWithMeridiem(lastUpdated.mappingsCache) : 'not cached'}
          </Typography>
          <Typography variant="body2">
            Indicative status updated:{' '}
            {lastUpdated.indicativePropertyState
              ? formatDateLongMonthWithMeridiem(lastUpdated.indicativePropertyState)
              : 'not cached'}
          </Typography>
        </Stack>
      )}
    </PropertyActionCard>
  );
}
